export async function getInitialProps({context: {domain}, routeInfo: {location}, routeInfo}) {
  const {
    query: {adId}
  } = location

  const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})

  if (adDetailsError) {
    return {
      __HTTP__: {
        redirectTo: '/'
      }
    }
  }

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: routeInfo.location.pathname})

  const getTrackingData = async () => {
    return domain.get('get_page_tracking_data_use_case').execute({
      page: pageName
    })
  }

  const pageTrackingData = await getTrackingData()

  return {
    adPrice: adDetailsResponse.ad?.price,
    adTitle: adDetailsResponse.ad?.title,
    pageName,
    pageTrackingData
  }
}
